import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { LockOutlined } from "@mui/icons-material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { UserRegister } from "../_api/registerApi";
import Cookies from "universal-cookie";
import PropTypes from "prop-types";
import { TimeLoader } from "../_components/loaders/TimeLoader";
// import { toast } from "react-toastify";
import { useToaster } from "../_components/toaster/MuiToasterProvider";
const componentStyles = (theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonIco: {
    width: 24,
    height: 24,
    marginRight: 10,
    marginTop: 7,
  },
  inputIco: {
    opacity: 0.6,
    color: "#1c355e",
    paddingRight: "5px",
  },
});
const StyledRoot = styled("div")(({ theme }) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce(
    (acc, [className, style]) => ({
      ...acc,
      [`& .${className}, &.${className}`]: style,
    }),
    {},
  ),
}));
const Password = ({ handleNext, UpdateUserInfo, userInfo }) => {
  const cookies = new Cookies();
  const [showSpinner, setShowSpinner] = useState(false);
  const [disableInputs, setDisableInputs] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const toast = useToaster();
  const showApiErrorToast = () => {
    toast.error(
      <div>
        <Typography
          variant="h6"
          style={{
            textDecoration: "underline",
          }}
        >
          {t("registration.apiErrorTitle")}
        </Typography>
        <Typography variant="body2">{t("registration.apiError")}</Typography>
      </div>,
    );
  };
  const { t } = useTranslation();
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const RegisterUser = (registerUserInfo) => {
    let registrationInformation = {
      brandIdentifier: registerUserInfo.brandIdentifier,
      firstName: registerUserInfo.firstName,
      lastName: registerUserInfo.lastName,
      email: registerUserInfo.email,
      password: registerUserInfo.password,
      homePhone: registerUserInfo.cellPhone,
      cellPhone: registerUserInfo?.cellPhone,
      homeAddress1: registerUserInfo.homeAddress1,
      homeAddress2: registerUserInfo.homeAddress2,
      city: registerUserInfo.city,
      county: registerUserInfo.county,
      state: registerUserInfo.state,
      zip: registerUserInfo.zip,
      dob: registerUserInfo.dob,
    };
    UserRegister(registrationInformation)
      .then((response) => {
        cookies.set("driveSaferUser", JSON.stringify(response), {
          path: "/",
          sameSite: "strict",
        });
        handleNext();
      })
      .catch((error) => {
        console.error("Error registering user : ", error);
        showApiErrorToast();
        setDisableInputs(false);
        setShowSpinner(false);
      });
  };
  const submitPassword = (data) => {
    setDisableInputs(true);
    setShowSpinner(true);
    UpdateUserInfo(data);
    RegisterUser({
      ...userInfo,
      ...data,
    });
  };
  return (
    <StyledRoot>
      <form className={"form"} onSubmit={handleSubmit(submitPassword)}>
        <TextField
          variant="outlined"
          margin="normal"
          autoComplete="new-password"
          size="small"
          fullWidth
          // required
          type={showPassword ? "text" : "password"}
          label={t("registration.password")}
          name="password"
          id="password"
          disabled={disableInputs}
          error={!!errors.password}
          helperText={errors.password ? errors.password.message : ""}
          autoFocus
          slotProps={{
            input: {
              "data-testid": "password",
              startAdornment: <LockOutlined className={"inputIco"} />,
              endAdornment: (
                <IconButton onClick={toggleShowPassword} size="large">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              ),
            },
            htmlInput: {
              ...register("password", {
                required: {
                  value: true,
                  message: t("registration.passwordRequired"),
                },
                pattern: {
                  value:
                    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,24}$/,
                  message: t("registration.passwordPattern"),
                },
              }),
            },
          }}
        />
        <TextField
          variant="outlined"
          margin="normal"
          autoComplete="new-password"
          size="small"
          fullWidth
          // required
          type={showPassword ? "text" : "password"}
          label={t("registration.confirmPassword")}
          name="confirmPassword"
          disabled={disableInputs}
          error={!!errors.confirmPassword}
          helperText={
            errors.confirmPassword ? errors.confirmPassword.message : ""
          }
          slotProps={{
            input: {
              startAdornment: <LockOutlined className={"inputIco"} />,
              endAdornment: (
                <IconButton onClick={toggleShowPassword} size="large">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              ),
            },
            htmlInput: {
              ...register("confirmPassword", {
                required: {
                  value: true,
                  message: t("registration.confirmPasswordRequired"),
                },
                pattern: {
                  value:
                    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,24}$/,
                  message: t("registration.passwordPattern"),
                },
                validate: (value) => {
                  if (value === watch("password")) {
                    return true;
                  } else {
                    return t("registration.confirmPasswordMatch");
                  }
                },
              }),
            },
          }}
        />

        <Grid
          container
          sx={{
            flexDirection: "column",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {showSpinner ? (
            <Grid
              style={{
                padding: 15,
                margin: 15,
              }}
            >
              <TimeLoader />
            </Grid>
          ) : (
            <Grid
              style={{
                paddingTop: 10,
                marginTop: 10,
                marginLeft: "-20px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{
                  width: 240,
                  height: 50,
                }}
              >
                {t("registration.createAccount")}
              </Button>
            </Grid>
          )}
        </Grid>
      </form>
    </StyledRoot>
  );
};
Password.propTypes = {
  userInfo: PropTypes.object,
  UpdateUserInfo: PropTypes.func,
  handleNext: PropTypes.func,
};
export default Password;
